import httpUtil from "@/utils/httpUtil";

export const selectStoreClassList = params => httpUtil.get("/storeClass/list", params);
export const setHierarchy = params => httpUtil.post("/storeClass/setHierarchy", params);

